module.exports = __webpack_public_path__ + "static/media/YF45_1.79a06cc6.jpg";